import React from 'react';
import { Flex } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';

export function LoadingState() {
	return (
		<Flex justifyContent="center">
			{/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */}
			<Spinner testId="project-directories.components.content.components-spinner" />
		</Flex>
	);
}
